// export this package's api
import Upload from './Upload';

export default Upload;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-upload@2.4.4@rc-upload/es/index.js
// module id = 1005
// module chunks = 0